import { type } from '../theme.js';
import { cn } from '../../lib/cn.js';

/**
 * 页头:标题 + 一句说明 + 右侧动作位。
 *
 * 抽出来是为了让七页的标题**真的一样大** —— 改之前五页 `text-lg`、
 * 两页 `text-lg` 但间距不同,并排截图放进演示脚本里一眼就看出来是拼的。
 *
 * `hint` 写「这一页能帮你干什么」,不写「这是询盘列表」。
 */
export function PageHeader({
  title,
  hint,
  action,
  className,
}: {
  title: string;
  hint?: string;
  action?: React.ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn('mb-5 flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h1 className={type.h1}>{title}</h1>
        {hint ? <p className={cn(type.caption, 'mt-1')}>{hint}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
